module.exports = __webpack_public_path__ + "media/Images/icon-download-o-0e2146ec6878ccc09d29a55d55b04377.svg";